import { Grid } from '@mui/material';
import { Spacer } from '../../../components';
import { HelpTitle, HelpBody } from '../../../components/HelpText';
import { ProgressCalculator } from './ReportProgressTracker';
import { findPricebookReportsByType } from '../../../data/report/helpers/pricebookReportUtils';
import { ProductTypeEnum } from '../../../models/PricebookData';
import { sumPropertyAcrossArrayItems } from '../../../helpers/utilityFunctions';

export const progressTrackerGuidedChoice: ProgressCalculator = summedReport => {
  const reportsGc = findPricebookReportsByType(summedReport, ProductTypeEnum.GuidedChoice);

  return {
    title: 'GuidedChoice onboarding',
    totalUsers: sumPropertyAcrossArrayItems(reportsGc, 'activeUserCount'),
    notStarted: summedReport?.notStartedGc ?? 0,
    inProgress: [],
    completed: sumPropertyAcrossArrayItems(reportsGc, 'onboardingCompletedCount'),
    helpText: 'GuidedChoice active users',
    helpContent: <HelpTextGc />,
  };
};

const HelpTextGc = () => {
  return (
    <Grid>
      <HelpTitle>GuidedChoice active users</HelpTitle>
      <Spacer height='xxs' />
      <HelpBody>
        Count of users connected to this organization who have an active GuidedChoice Advisory
        Service license.
      </HelpBody>
    </Grid>
  );
};
